module.exports = __webpack_public_path__ + "static/img/3.69424cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/3.png
// module id = yY18
// module chunks = 35